import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a94102c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a94102c&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=4a94102c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94102c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a94102c')) {
      api.createRecord('4a94102c', component.options)
    } else {
      api.reload('4a94102c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a94102c&scoped=true", function () {
      api.rerender('4a94102c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/form/input/IkFormDate/index.vue"
export default component.exports